import {i18n} from "../../shared/i18n";

export const MAX_GALLERY_FILE_SIZE = 5 * 1024 * 1024;

const fileName = (file) => file?.name || i18n.t("orgs.gallery.unnamed");

export const validateGalleryFiles = (files = []) => {
    const selectedFiles = Array.from(files);
    const invalidType = selectedFiles.find((file) => !String(file?.type || "").startsWith("image/"));
    if (invalidType) {
        return i18n.t("orgs.gallery.invalidType", {name: fileName(invalidType)});
    }

    const oversized = selectedFiles.find((file) => Number(file?.size || 0) > MAX_GALLERY_FILE_SIZE);
    if (oversized) {
        return i18n.t("orgs.gallery.tooLarge", {name: fileName(oversized)});
    }

    return "";
};
